module.exports = __webpack_public_path__ + "img/longSentence.e0efb826.jpg";